import type { Handler } from './handler';
import type { ApiFetchPerfilOficialBannersPort } from './ports/api-fetch-perfil-oficial-banners.port';
import type { BannerItem } from '~/utils/perfilOficialConfigs';
import { tryCatch } from '~/utils/apostatudo/try-catch';
import { resolveAdapter } from '~/adapters/registry';

export const fetchPerfilOficialBannersHandler: Handler<
  Params,
  Ports,
  Result
> = async (
  params,
  ports = {
    apiFetchPerfilOficialBanners: resolveAdapter(
      'apiFetchPerfilOficialBanners',
    ),
  },
) => {
  const [banners, fetchError] = await tryCatch(
    ports?.apiFetchPerfilOficialBanners.handle(params.slug),
  );

  if (fetchError) {
    console.error(
      '[fetchPerfilOficialBannersHandler] Erro ao buscar banners da API:',
      fetchError,
    );

    return { banners: [] };
  }

  return { banners: banners || [] };
};

type Params = { slug: string };

type Ports = {
  apiFetchPerfilOficialBanners: ApiFetchPerfilOficialBannersPort;
};

type Result = Promise<{ banners: BannerItem[] }>;
